module.exports = __webpack_public_path__ + "static/media/appInfo5.c75d2a73.png";